import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetPriorityParams } from '../types/actionParams';

export class SetExtractTasksPriorityRequest extends Request<ISetPriorityParams, IResult> {
  constructor(ids: string[], priority: number) {
    super('setExtractTasksPriority', {
      ids: ids,
      priority: priority
    });
  }
}
